"use client";

import { Button } from "@commerce-frontend/ui/base/Button";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import {
	ToastClose,
	ToastDescription,
	ToastPortal,
	ToastProvider,
	ToastRoot,
	ToastTitle,
	ToastViewport,
} from "@commerce-frontend/ui/components/Toast/Toast";
import { useTranslations } from "next-intl";
import { useLayoutEffect, useState } from "react";
import { useAddToCartContext } from "~/components/AddToCartContext";

export function ProductAddErrorToast() {
	const t = useTranslations("ProductAddErrorToast");
	const { errorIsOpen, setErrorOpen } = useAddToCartContext();
	const [visible, setVisible] = useState(false);

	useLayoutEffect(() => {
		setVisible(true);
	}, []);

	if (!visible) {
		return null;
	}

	return (
		<ToastProvider>
			<ToastPortal>
				<ToastRoot open={errorIsOpen} onOpenChange={setErrorOpen}>
					<ToastClose aria-label={t("close")} asChild>
						<span aria-hidden>
							<Button
								className="focus:ring-accent-level-2 group relative -right-2.5 -top-2.5 size-11 rounded-xs text-gray-400 hover:bg-gray-50 hover:text-gray-500 focus:bg-gray-50"
								variant="link"
								aria-label={t("close")}
							>
								<Icon
									icon="x-close"
									className="size-6 bg-gray-400 transition-colors group-hover:bg-gray-700"
								/>
							</Button>
						</span>
					</ToastClose>
					<div className="flex size-8 items-center justify-center rounded-full bg-error-100 p-md">
						<Icon icon="alert-circle" className="size-4 bg-error-600" />
					</div>
					<div className="pr-3xl">
						<ToastTitle>{t("title")}</ToastTitle>
						<ToastDescription>{t("description")}</ToastDescription>
					</div>
				</ToastRoot>
				<ToastViewport />
			</ToastPortal>
		</ToastProvider>
	);
}
